import React from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import appVersion from "../../version";
// import Record from "../QuestionsList/Record";

const ErrorPage = () => {
  const location = useLocation();
  const { visitorData } = location.state || {};
  const app_ver = appVersion.app_ver;
   const date = appVersion.date
  // console.log(location.state);
  // console.log(visitorData);
  // console.log(visitorData?.resp);
  // console.log(visitorData?.resp?.message);

  // Check if visitorData and visitorData.resp exist before accessing message
  const errorMessage =
    visitorData?.resp?.message || "Bot Not Authorized ";

  return (
    <div className="login-container">
     <Header/>
      <p>{errorMessage}</p>
      {/* <Record/> */}
      <p style={{ fontSize: "14px", position: "fixed", bottom: "0" }}>
          Version : {app_ver} | {date}
        </p>
    </div>
  );
};

export default ErrorPage;
